import { useCallback, useEffect, useState } from 'react'
import axiosReadInstance from '@request/axiosReadInstance'
import { API_URL } from '@constants'
import type {
    NavbarExpertisePage,
    NavbarPagesResult,
    NavbarPath,
} from './nav.types'

export function useNavbarNavData(): {
    loading: boolean
    paths: NavbarPath[]
    expertisePages: NavbarExpertisePage[]
} {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<NavbarPagesResult>()
    const [expertisePages, setExpertisePages] = useState<NavbarExpertisePage[]>(
        []
    )

    const fetchData = useCallback(async () => {
        setLoading(true)
        await axiosReadInstance
            .get(`${API_URL}/api/pages`, {
                params: {
                    sort: 'position:asc',
                    fields: ['url', 'name', 'position'],
                },
            })
            .then((response) => {
                setData(response.data)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    const fetchExpertisePages = useCallback(async () => {
        await axiosReadInstance
            .get(`${API_URL}/api/expertises-pages?populate=*`)
            .then((response) => {
                setExpertisePages(response.data.data)
            })
    }, [])

    useEffect(() => {
        fetchData()
        fetchExpertisePages()
    }, [fetchData, fetchExpertisePages])

    return {
        loading,
        paths: data?.data ?? [],
        expertisePages,
    }
}
